// extracted by mini-css-extract-plugin
module.exports = {"container":"i_DQ","dark":"i_DR","light":"i_DS","button":"i_DT"};